import request from 'api/axiosClient';

export const getDataDangKyDichVu = async (values) => {
    const result = await request({
        url: 'premium-report/data-statistics',
        method: 'POST',
        data: values,
    });
    return result?.data;
};

export const getGraphicalDangKyDichVu = async (values) => {
    const result = await request({
        url: 'premium-report/graphical-statistics',
        method: 'POST',
        data: values,
    });
    return result?.data;
};
